import React from 'react';

const getContact = (id, applicableContacts) => applicableContacts.find((c) => c.id == id) || {id, first_name: "UNKNOWN", last_name: "UNKNOWN"};

const matchKind = (matched, contact) => {
  switch(matched){
    case 'lastFirst':
      return `LastName, FirstName (${contact.last_name} ${contact.first_name})`;
    case 'firstLast':
      return `FirstName LastName (${contact.first_name} ${contact.last_name})`;
    case 'last':
      return `Last Name (${contact.last_name})`;
    case 'First':
      return `First Name (${contact.first_name})`;
    default:
      return matched;
  }
};

const Var = ({label, value}) => <div>
  <span className="bulk-file-page-inspect-label">
    {label}
  </span>
  <span className="bulk-file-page-inspect-value">
    {value}
  </span>
</div>;

export default ({bulkFilePage, applicableContacts}) => {
  const matches = bulkFilePage.matches || [];

  return <div className="bulk-file-page-inspect">
    <h2>Extracted Text</h2>
    <div className="bulk-file-page-inspect-value">
      {bulkFilePage.text || "[None]"}
    </div>

    <h2>{matches.length} Matches</h2>
    {matches.map((match, i) => {
      const contact = getContact(match.contact_id, applicableContacts);

      return <div className="bulk-file-page-inspect-match" key={`match_${i}`}>
        <div className="bulk-file-page-inspect-match-header">{contact.last_name}, {contact.first_name}</div>

        <Var label="ID" value={match.contact_id}/>
        <Var label="Matched Text" value={match.score.value}/>
        <Var label="Looked Like" value={matchKind(match.score.matched, contact)}/>
        <Var label="Score" value={match.score.score}/>

        <div className="bulk-file-page-inspect-label">Score Details</div>
        <div className="bulk-file-page-inspect-value">{JSON.stringify(match.score.details)}</div>
      </div>
    })}
  </div>;
}